var exports = {
  "i": "xaee3c4fa--0a94d6--wrapper",
};

module.exports = exports;
